import { render, staticRenderFns } from "./BettorInfo.vue?vue&type=template&id=025736cc&"
import script from "./BettorInfo.vue?vue&type=script&lang=js&"
export * from "./BettorInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VBtn,VDialog})


/* hot reload */
if (module.hot) {
  var api = require("/builds/websites/vigzero/vig-zero-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('025736cc')) {
      api.createRecord('025736cc', component.options)
    } else {
      api.reload('025736cc', component.options)
    }
    module.hot.accept("./BettorInfo.vue?vue&type=template&id=025736cc&", function () {
      api.rerender('025736cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/wagers/BettorInfo.vue"
export default component.exports